(() => {
  const init = () => {
    document.querySelectorAll(".sticky-atc").forEach((root) => {
      const sectionId = root.getAttribute("data-section-id");
      const productFormId = root.getAttribute("data-product-form-id");
      const customButtonWrapperId = root.getAttribute("data-custom-button-wrapper-id");

      const stickyButton = root.querySelector("[data-sticky-atc-button]");
      const priceNode = root.querySelector("[data-sticky-atc-price]");
      const titleNode = root.querySelector("[data-sticky-atc-title]");
      const variantNameNode = root.querySelector("[data-sticky-atc-variant-name]");

      const productForm = document.getElementById(productFormId);
      const mainAddButton =
        productForm && productForm.querySelector('button[name="add"], button[type="submit"]');
      const customWrapper = customButtonWrapperId && document.getElementById(customButtonWrapperId);
      const fallbackAddButton =
        customWrapper && customWrapper.querySelector('button[name="add"], button[type="submit"]');

      const sectionScope = root.closest(".shopify-section") || document;

      const getActiveOptionRoot = () => {
        const activePanel = sectionScope.querySelector(".tabbed-product-block__panel--active");
        const activeInPanel = activePanel && activePanel.querySelector(".active-product");
        if (activeInPanel) return activeInPanel;

        return sectionScope.querySelector(".active-product");
      };

      const submitActiveCardForm = () => {
        const active = getActiveOptionRoot();
        if (!active) return false;

        const form = active.querySelector("product-form form, form");
        if (!form) return false;

        const idInput = form.querySelector('input[name="id"][disabled]');
        if (idInput) idInput.disabled = false;

        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        }
        return true;
      };

      const syncFromActiveCard = () => {
        if (!priceNode && !titleNode && !variantNameNode) return;

        const active = getActiveOptionRoot();
        if (!active) return;

        if (titleNode) {
          const h3 = active.querySelector("h3");
          const title = (h3 && h3.textContent && h3.textContent.trim()) || "";
          if (title) titleNode.textContent = title;
        }

        if (variantNameNode) {
          const heading = active.querySelector(".card__heading");
          const variantTitle = (heading && heading.textContent && heading.textContent.trim()) || "";
          if (variantTitle) variantNameNode.textContent = variantTitle;
        }

        if (priceNode) {
          const priceEl =
            active.querySelector(".gift-price .price-item--regular") ||
            active.querySelector(".gift-price .price-item") ||
            active.querySelector(".price-item--regular") ||
            active.querySelector(".price-item");
          const priceText = (priceEl && priceEl.textContent && priceEl.textContent.trim()) || "";
          if (priceText) priceNode.textContent = priceText;
        }
      };

      const updateBottomPadding = () => {
        if (root.classList.contains("sticky-atc--hidden")) return;
        const h = root.getBoundingClientRect().height || 0;
        document.documentElement.style.setProperty("--sticky-atc-height", `${Math.ceil(h)}px`);
        document.body.style.paddingBottom = "var(--sticky-atc-height)";
      };

      const clearBottomPadding = () => {
        document.documentElement.style.removeProperty("--sticky-atc-height");
        document.body.style.removeProperty("padding-bottom");
      };

      const setVisible = (visible) => {
        root.classList.toggle("sticky-atc--hidden", !visible);
        if (visible) updateBottomPadding();
        else clearBottomPadding();
      };

      const triggerEl = productForm || customWrapper;
      if (triggerEl) {
        const TRIGGER_OFFSET = 100;
        let hasSeenTrigger = false;
        const atcObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              hasSeenTrigger = true;
              setVisible(false);
              return;
            }

            const viewportH =
              (entry.rootBounds && entry.rootBounds.height) || window.innerHeight || document.documentElement.clientHeight;
            const isBelowViewport = entry.boundingClientRect.top >= viewportH;
            const isAboveViewport = entry.boundingClientRect.bottom <= TRIGGER_OFFSET;

            if (isBelowViewport) {
              setVisible(false);
              return;
            }

            if (isAboveViewport) {
              setVisible(hasSeenTrigger);
              return;
            }

            setVisible(false);
          },
          { threshold: 0, rootMargin: `-${TRIGGER_OFFSET}px 0px 0px 0px` }
        );
        atcObserver.observe(triggerEl);
      }

      window.addEventListener("resize", updateBottomPadding);

      const getSourceButton = () => {
        const currentMainAdd = productForm && productForm.querySelector('button[name="add"], button[type="submit"]');
        const currentFallback = customWrapper && customWrapper.querySelector('button[name="add"], button[type="submit"]');
        return currentMainAdd || currentFallback;
      };

      const syncDisabledFromMain = () => {
        if (!stickyButton) return;
        const sourceButton = getSourceButton();
        if (sourceButton) {
          const disabled =
            sourceButton.hasAttribute("disabled") || sourceButton.getAttribute("aria-disabled") === "true";
          stickyButton.toggleAttribute("disabled", disabled);
          return;
        }

        const active = getActiveOptionRoot();
        const activeSubmit =
          active && active.querySelector('button[name="add"], button[type="submit"]');
        if (activeSubmit) {
          stickyButton.toggleAttribute("disabled", activeSubmit.hasAttribute("disabled"));
        }
      };

      syncDisabledFromMain();
      syncFromActiveCard();

      if (mainAddButton) {
        const observer = new MutationObserver(syncDisabledFromMain);
        observer.observe(mainAddButton, {
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled"],
        });
      }

      if (customWrapper) {
        const wrapperObserver = new MutationObserver(syncDisabledFromMain);
        wrapperObserver.observe(customWrapper, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled"],
        });
      }

      // Make review count in sticky bar link to /pages/reviews
      root.addEventListener("click", (e) => {
        const count = e.target.closest(".ruk-rating-snippet-count");
        if (count) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = "/pages/reviews";
        }
      }, true);

      if (stickyButton) {
        stickyButton.addEventListener("click", () => {
          if (stickyButton.hasAttribute("disabled")) return;

          if (submitActiveCardForm()) return;

          const sourceButton = getSourceButton();
          if (sourceButton) sourceButton.click();
        });
      }

      sectionScope.addEventListener("click", (e) => {
        const option = e.target && e.target.closest && e.target.closest(".single-gift-sub-button, [data-variant-id]");
        if (!option) return;
        window.requestAnimationFrame(syncFromActiveCard);
      });

      // Sync variant name when tab changes (subscribe/one-time)
      sectionScope.querySelectorAll("tabbed-product-block").forEach((tabbedBlock) => {
        tabbedBlock.addEventListener("tabChanged", () => {
          window.requestAnimationFrame(syncFromActiveCard);
        });
      });

      const activeObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          // Ignore mutations inside the sticky CTA itself to prevent infinite loops
          if (m.target && m.target.closest && m.target.closest(".sticky-atc")) continue;

          if (m.type === "attributes" && m.attributeName === "class") {
            const el = m.target;
            if (el && el.classList && (el.classList.contains("active-product") || el.querySelector?.(".active-product"))) {
              window.requestAnimationFrame(syncFromActiveCard);
              break;
            }
          }
          if (m.type === "childList") {
            window.requestAnimationFrame(syncFromActiveCard);
            break;
          }
        }
      });
      activeObserver.observe(sectionScope, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event && event.data;
          if (!data || data.sectionId !== sectionId) return;

          const variant = data.variant;
          if (!variant) return;

          if (priceNode && window.Shopify && typeof Shopify.formatMoney === "function") {
            priceNode.textContent = Shopify.formatMoney(variant.price, Shopify.money_format);
          }

          if (variantNameNode && variant.name) {
            const parts = variant.name.split(" - ");
            const variantTitle = parts.length > 1 ? parts.slice(1).join(" - ") : variant.name;
            variantNameNode.textContent = variantTitle;
          }

          if (stickyButton) {
            stickyButton.toggleAttribute("disabled", !variant.available);
          }
        });
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

